import { render } from "./return_asset_delete_btn.vue?vue&type=template&id=53e0f2a2&scoped=true"
import script from "./return_asset_delete_btn.vue?vue&type=script&lang=js"
export * from "./return_asset_delete_btn.vue?vue&type=script&lang=js"

import "./return_asset_delete_btn.vue?vue&type=style&index=0&id=53e0f2a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e0f2a2"]])

export default __exports__